import React from "react";
import MyCard7 from "./MyCard7";
import { MyColors } from "../util/my_colors";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MyCard10 from "./MyCard10";
import {
  CalendarDays,
  ChevronRight,
  Clapperboard,
  TvMinimalPlay,
  UserRoundPlus,
} from "lucide-react";

export default function PostCard({ className }) {
  return (
    <MyCard7 className={` ${className}`}>
      <div className="flex flex-col">
        <div className="flex items-center justify-start ">
          <YouTubeIcon
            className={`mr-2  ${MyColors.red.text}`}
            sx={{ fontSize: 24 }}
          />

          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
            Post
          </span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 items-start justify-start mt-4">
          <VideoCard />
          <VideoCard />
          <VideoCard />
        </div>
      </div>
    </MyCard7>
  );
}

export function VideoCard() {
  return (
    <>
      <div className="flex flex-col">
        <img className="rounded-lg" src="https://i.ytimg.com/vi/0EfY1LMZJv8/mqdefault.jpg" alt="" />
        <span className=" line-clamp-2 mt-2 text-[10px] text-slate-800 dark:text-slate-300">🤑🔥 New Earning App Today 2026 || Cash Monkey App Withdrawal Real Or Fake 💯🤯 Make Money Online</span>
       {/* video stats */}
        <div></div>
      </div>
    </>
  );
}
